import R from "@/modules/billing/referral/ReferralProgram.module.css";

import T from "@/components/forms/TextField.module.css";
import { UnconvertedCurrencyBalance } from "@/components/l10n/Currency.tsx";
import { siteCurrencyAtom } from "@/config.ts";
import type { CurrencyInfo } from "@/modules/currency/currencyInfo.ts";
import type { DisplayAmount } from "@/modules/currency/currencyTypes.ts";
import { cn } from "@/utils/classNames.ts";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai/react";
import { Label } from "react-aria-components";

export function BaseCurrencyField({ value, currency }: { value: DisplayAmount; currency: CurrencyInfo }) {
    const siteCurrency = useAtomValue(siteCurrencyAtom);

    if (currency.isSite) {
        // If the currency is the site currency, we don't need to display it.
        return null;
    }

    return (
        <div className={T.NumberField}>
            <Label className={cn(T.Label, "color-muted")}>
                <Trans>Base currency</Trans>
            </Label>
            <div className={R.dummyField}>
                <div className={cn(T.Input, "flex items-center")} data-disabled="1">
                    <UnconvertedCurrencyBalance value={currency.toSite(value)} currency={siteCurrency} />
                </div>
            </div>
        </div>
    );
}
